import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const TopTabs = (props) => {
  const { data, size, classNameTabs } = props;
  const { pathname } = useLocation();

  let decodedUrl = pathname.replace(/%20/g, " ");
  return (
    <div className={`top-tabs ${size}`}>
      <div className={`tabs ${classNameTabs}`}>
        {data.map((item) => (
          <Link to={item.url} key={item.name} className={`tab ${decodedUrl.includes(item.url) ? "active" : ""}`}>
            <p>{item.name}</p>
          </Link>
        ))}
      </div>

      <Outlet />
    </div>
  );
};

export default TopTabs;
